import routerLive from '@/pages/Lives/router';
import store from '@/store/index';

routerLive.beforeEach((to, from, next) => {
  const title = to.meta.title || '';
  store.commit('SET_APP_TITLE', title);

  // 防止从预约页面，通过返回按钮回到列表页后再次重新获取数据
  if (to.name === 'addLive') {
    to.meta.addSucess = false;
  }

  // 用于添加成功后，返回列表页，重新获取数据
  if (from.name === 'addLive' && from.meta.addSucess) {
    to.meta.refresh = true;
  }

  // document.title = to.meta.title;

  next();
});
